// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2657":"ce7fae8c","4380":"5eacc0f2"}[chunkId] + ".chunk.css";
};